import {
  getBoolean,
  getList,
} from "@surya-digital/leo-ts-types";
import { TableFilter, TableFilterDTO, TableFilterEnums } from "./tableFilter";


export namespace RespondentSelection {
  export interface AllRowsSelectedDTO {
    case: string;
    isLive: boolean;
    filters: TableFilterDTO[];
  }
  
  export class AllRowsSelected {
    readonly isRespondentSelectionAllRowsSelected: boolean = true;
  
    readonly isLive: boolean;
    readonly filters: TableFilter[];
  
    static readonly constraints = {
      "filters": {
        "maxSize": 5,
      }
    }
  
    constructor(
    isLive: boolean, 
    filters: TableFilter[]
    ) {
      this.isLive = isLive;
      AllRowsSelected.validateFilters(filters);
      this.filters = filters;
    }
  
    static fromDTO(dto: AllRowsSelectedDTO): AllRowsSelected {
      const isLive = getBoolean(dto, "isLive", InvalidRespondentSelectionAllRowsSelectedIsLiveError);
      const filters = getList<TableFilterDTO, TableFilter>(
        dto,
        "filters",
        TableFilter.fromDTO,
        InvalidRespondentSelectionAllRowsSelectedFiltersError
      );
      return new AllRowsSelected(
        isLive,
        filters
      );
    }
  
    toDTO(): AllRowsSelectedDTO {
      const dto: AllRowsSelectedDTO = {
        case: "ALL_ROWS_SELECTED",
          isLive: this.isLive,
          filters: this.filters.map((e: TableFilter) => { return e.toDTO() })
      };
      return dto;
    }
    private static validateFilters = (filters: TableFilter[]): void => {
      if(filters.length > 5) {
        throw new InvalidRespondentSelectionAllRowsSelectedFiltersMaxSizeError(
          5,
          `Attribute filters is too long. Size is ${filters.length}. Max size is 5.`
        );
      }
    }
    
  }
  
  AllRowsSelected.prototype.toString = function toString(): string {
    return `RespondentSelection.ALL_ROWS_SELECTED(isLive='${this.isLive}',filters='${this.filters}')`;
  };
  
  export interface SomeRowsSelectedDTO {
    case: string;
    selectedRespondentIds: number[];
  }
  
  export class SomeRowsSelected {
    readonly isRespondentSelectionSomeRowsSelected: boolean = true;
  
    readonly selectedRespondentIds: number[];
  
  
    constructor(
    selectedRespondentIds: number[]
    ) {
      this.selectedRespondentIds = selectedRespondentIds;
    }
  
    static fromDTO(dto: SomeRowsSelectedDTO): SomeRowsSelected {
      const selectedRespondentIds = getList<number, number>(
        dto,
        "selectedRespondentIds",
        (e: number) => e,
        InvalidRespondentSelectionSomeRowsSelectedSelectedRespondentIdsError
      );
      return new SomeRowsSelected(
        selectedRespondentIds
      );
    }
  
    toDTO(): SomeRowsSelectedDTO {
      const dto: SomeRowsSelectedDTO = {
        case: "SOME_ROWS_SELECTED",
          selectedRespondentIds: this.selectedRespondentIds
      };
      return dto;
    }
    }
  
  SomeRowsSelected.prototype.toString = function toString(): string {
    return `RespondentSelection.SOME_ROWS_SELECTED(selectedRespondentIds='${this.selectedRespondentIds}')`;
  };
  

  export type RespondentSelection = AllRowsSelected | SomeRowsSelected;

  export type RespondentSelectionDTO = AllRowsSelectedDTO | SomeRowsSelectedDTO;

  export const fromDTO = (dto: RespondentSelectionDTO): RespondentSelection => {
    switch (dto.case) {
      case "ALL_ROWS_SELECTED":
          return AllRowsSelected.fromDTO(dto as AllRowsSelectedDTO);
      case "SOME_ROWS_SELECTED":
          return SomeRowsSelected.fromDTO(dto as SomeRowsSelectedDTO);
      default:
        throw new InvalidRespondentSelectionError(
            `Case ${dto.case} is not valid case of RespondentSelection.`
        );
    }
  };
}

export class InvalidRespondentSelectionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionError";
  }
}
export class InvalidRespondentSelectionAllRowsSelectedError extends InvalidRespondentSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionAllRowsSelectedError";
  }
}

export class InvalidRespondentSelectionAllRowsSelectedIsLiveError extends InvalidRespondentSelectionAllRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionAllRowsSelectedIsLiveError";
  }
}

export class InvalidRespondentSelectionAllRowsSelectedFiltersError extends InvalidRespondentSelectionAllRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionAllRowsSelectedFiltersError";
  }
}

export class InvalidRespondentSelectionAllRowsSelectedFiltersMaxSizeError extends InvalidRespondentSelectionAllRowsSelectedFiltersError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionAllRowsSelectedFiltersMaxSizeError";
  }
}

export class InvalidRespondentSelectionSomeRowsSelectedError extends InvalidRespondentSelectionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionSomeRowsSelectedError";
  }
}

export class InvalidRespondentSelectionSomeRowsSelectedSelectedRespondentIdsError extends InvalidRespondentSelectionSomeRowsSelectedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRespondentSelectionSomeRowsSelectedSelectedRespondentIdsError";
  }
}
